import { apiClient } from './api';

export const userService = {
    async getUsers(params = {}) {
        try {
            const response = await apiClient.get('/users', { params });
            return response.data;
        } catch (error) {
            console.error('获取用户列表失败:', error);
            throw error;
        }
    },

    async getUserById(userId) {
        try {
            const response = await apiClient.get(`/users/${userId}`);
            return response.data;
        } catch (error) {
            console.error('获取用户详情失败:', error);
            throw error;
        }
    },

    async createUser(userData) {
        try {
            const response = await apiClient.post('/users', userData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('创建用户失败:', error);
            throw error;
        }
    },

    async updateUser(userId, userData) {
        try {
            const response = await apiClient.put(`/users/${userId}`, userData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('更新用户失败:', error);
            throw error;
        }
    },

    async deleteUser(userId) {
        try {
            const response = await apiClient.delete(`/users/${userId}`);
            return response.data;
        } catch (error) {
            console.error('删除用户失败:', error);
            throw error;
        }
    },

    async resetPassword(userId) {
        try {
            const response = await apiClient.post(`/users/${userId}/reset-password`);
            return response.data;
        } catch (error) {
            console.error('重置密码失败:', error);
            throw error;
        }
    },

    async updateUserStatus(userId, status) {
        try {
            const response = await apiClient.patch(`/users/${userId}/status`, { status });
            return response.data;
        } catch (error) {
            console.error('更改用户状态失败:', error);
            throw error;
        }
    }
};

export default userService;